<template>
  <div>
    <div v-if="!isEdit" class="detail-title" :style="`color:${ getPrimary(color)}`">
      {{ $t("Views.Customer.discountByProducts") }}
    </div>
    <material-table
      :headers="headers"
      :items="items"
      :has-paginate="false"
      @add="addFn"
      @remove="removeFn"
    />
  </div>
</template>

<script>
import ENUMS from '@/dict/enums'
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: () => false
    },
    isUpdate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const $t = this.$t.bind(this)
    return {
      sectionValid: [],
      priceValid: [],
      headers: [
        {
          // '商品',
          text: $t('Views.Goods.productName'),
          width: 400,
          render: (h, param) => {
            return h('ams-add-productLinks', {
              props: {
                items: param,
                selectedItems: this.items,
                disCount: true,
                isMoreBtn: false,
                isClearable: true
              },
              on: {
                change: item => {
                  this.$set(
                    this.items,
                    param.index,
                    {
                      productId: item.id,
                      orderPrice: item.orderPrice,
                      product: item,
                      detail: [{
                        discountValue: '',
                        maxQuantity: '',
                        minQuantity: 1
                      }]
                    }
                  )
                },
                clear: () => {
                  this.$set(
                    this.items[param.index],
                    'orderPrice',
                    null
                  )
                  this.$set(
                    this.items[param.index],
                    'productId',
                    null
                  )
                  this.$set(
                    this.items[param.index],
                    'product',
                    null
                  )
                }
              }
            })
          }
        },
        {
          width: 440,
          text: $t('Views.Customer.quantity'),
          render: (h, param) => {
            return h('ams-quantity-section', {
              props: {
                data: param.row.detail,
                rules: [
                  v => !!v || $t('Core.Valid.required'),
                  v => v * 1 <= 99999 || $t('Core.Valid.max', { max: 99999 }),
                  v => v * 1 >= 1 || $t('Core.Valid.min', { min: 1 })
                ],
                config: {
                  max: 'maxQuantity',
                  min: 'minQuantity'
                },
                max: 99999, // 允许的最大值
                min: 1, // 允许的最小值
                step: 1000 // 每次新增一条的最大值和最小值的区间步长
              },
              on: {
                change: (source, valid) => {
                  if (source === null) return
                  this.sectionValid[param.index] = valid
                  this.$set(this.items[param.index], 'detail', source)
                }
              }
            })
          }
        },
        {
          text: $t('Views.Goods.orderPrice'),
          value: 'product.orderPrice',
          isCurrency: {
            type: 'nest'
          }
        },
        {
          width: 200,
          text: $t('Views.Customer.discountPrice'),
          render: (h, param) => {
            return h('ams-ipt-box', {
              props: {
                data: param.row.detail,
                rules: [
                  v => !!v || $t('Core.Valid.required'),
                  v => v * 1 >= 0 || $t('Core.Valid.min', { min: 0 }),
                  v => v * 1 <= param.row.product.orderPrice || $t('Core.Valid.max', { max: $t('Views.Customer.orderPrice') }),
                  v => {
                    if (!String(v) || !String(v).split('.')[1]) return false
                    return v.split('.')[1].length < 3 || $t('Core.Valid.float', { digit: 2 })
                  }
                ],
                config: {
                  value: 'discountValue'
                }
              },
              on: {
                change: (source, valid) => {
                  if (source === null) return
                  this.priceValid[param.index] = valid
                  this.$set(this.items[param.index], 'detail', source)
                }
              }
            })
          }
        }
      ],
      items: []
    }
  },
  computed: {
    color() {
      return this.$store.state.app.color
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal) {
        this.items = this.$_.cloneDeep(newVal)
      }
    }
  },
  created() {
    this.items = this.$_.cloneDeep(this.value)
  },
  mounted() {
    if (!this.isEdit) {
      this.headers.push({
        text: this.$t('Core.System.operate'),
        value: 'action',
        isActions: true
      })
    }
  },
  methods: {
    addFn(index, key) {
      this.items.splice(index + 1, 0, {
        productId: '',
        detail: null
      })
    },
    getPrimary(color) {
      return ENUMS.primaryColor[color]
    },
    removeFn(index, key) {
      this.items.splice(index, 1)
    },
    emitChange() {
      this.$emit('input', this.items)
      const sectionValid = this.items.every((item, index) => {
        return !item.productId ? true : (
          this.sectionValid[index] ? this.sectionValid[index].validate() : (this.isUpdate || (this.isEdit && true))
        )
      })
      const priceValid = this.items.every((item, index) => {
        return !item.productId ? true : (
          this.priceValid[index] ? this.priceValid[index].validate() : (this.isUpdate || (this.isEdit && true))
        )
      })
      const goodsValid = this.items.filter(item => item.productId).length > 0

      return {
        section: sectionValid,
        price: priceValid,
        goods: goodsValid
      }
    }
  }
}
</script>
